<template>
	<div class="card card-accent-success mb-3">
		<div class="card-header px-3 py-2 d-flex">
			<div class="flex-grow-1">
				<i class="far fa-calendar-alt fa-lg mr-2"></i>{{ __('translations.label.date') }}
			</div>
			<transition name="slide-fade">
				<div v-if="success" class="text-success">
					<i class="fas fa-check d-inline-block mr-2"></i>Enregistrée.
				</div>
			</transition>
		</div>
		<div class="card-body p-3">
			<form autocomplete="off">
				<div class="form-group row">
					<div class="col-6">
						<div class="btn-group btn-group-toggle w-100" data-toggle="buttons">
						  <label class="btn btn-sm btn-outline-secondary" :class="{'active': form.dateExactFlag}">
						    <input type="radio" name="options" id="option1" :value="true" autocomplete="off" v-model="form.dateExactFlag"> Date exacte
						  </label>
						  <label class="btn btn-sm btn-outline-secondary" :class="{'active': !form.dateExactFlag}">
						    <input type="radio" name="options" id="option2" :value="false" autocomplete="off" v-model="form.dateExactFlag"> Date approximative
						  </label>
						</div>
					</div>
				</div>
				<div class="form-group row">
					<div class="col-6">
						<input class="form-control form-control-sm mr-3" v-model="form.dateFrom" type="tel" placeholder="JJ.MM.AAAA" v-mask="'##.##.####'" />
						<div v-if="errors && errors.dateFrom" class="text-danger"><small>{{ errors.dateFrom[0] }}</small></div>
					</div>
					<div v-if="!form.dateExactFlag" class="col-6">
						<input class="form-control form-control-sm mr-3" v-model="form.dateTo" type="tel" placeholder="JJ.MM.AAAA" v-mask="'##.##.####'" />
						<div v-if="errors && errors.dateTo" class="text-danger"><small>{{ errors.dateTo[0] }}</small></div>
					</div>
				</div>
				<div class="form-group row" v-if="!form.dateExactFlag">
					<div class="col-12">
						<input type="text" class="form-control form-control-sm" name="date_description" v-model="form.dateDesc" :placeholder="__('translations.label.date_description')" maxlength="255" />
						<div v-if="errors && errors.date_description" class="text-danger"><small>{{ errors.value[0] }}</small></div>
					</div>
				</div>
				<div class="form-group row mb-0">
					<div class="col-12">
						<button type="submit" @click.prevent="save" class="btn btn-sm btn-success">{{ __('translations.button.save') }}</button>
						<button type="button" class="btn btn-sm btn-light" @click="resetForm">{{ __('translations.button.cancel') }}</button>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import {mask} from 'vue-the-mask'
import _ from 'lodash';

export default {
	props: ['source', 'sourceType'],
	directives: {mask},
	data() {
		return {
			form: {
				dateFrom: this.source.date_from,
				dateTo: this.source.date_to,
				dateDesc: this.source.date_description,
				dateExactFlag: !this.source.date_from || (!this.source.date_description && !this.source.date_to),
				sourceId: this.source.id,
				sourceType: this.sourceType,
			},
			success: false,
			errors: [],
		}
	},
	watch: {
		'form.dateExactFlag': function(isExactDateSelected) {
			this.errors = [];
		}
	},
	methods: {
		save() {
			this.success = false;
			this.errors = [];
			
			axios.post('/saveDate', this.form).then(response => {
				this.success = true;
				
				Vue.set(this.source, 'date_from', this.form.dateFrom);
				Vue.set(this.source, 'date_to', this.form.dateTo);
				Vue.set(this.source, 'date_description', this.form.dateDesc);
				
				setTimeout(() => {
					this.success = false;
				}, 3000);
			}).catch(error => {
				if (error.response.status === 422) {
					this.errors = error.response.data.errors || {};
				} else {
					console.log(error);
				}
			});
		},
		resetForm() {
			this.form.dateFrom = this.source.date_from;
			this.form.dateTo = this.source.date_to;
			this.form.dateDesc = this.source.date_description;
			this.form.dateExactFlag = !this.source.date_from || (!this.source.date_description && !this.source.date_to);
			this.success = false;
			this.errors = [];
		},
	}
}
</script>